import { ContainerSkeletonCard } from "./styles";
import { useTheme } from "../../../contexts/Theme/ThemeContext";

interface SkeletonCardMetricaProps {
  altura?: string;
}

const SkeletonCardMetrica: React.FC<SkeletonCardMetricaProps> = ({
  altura
}) => {
  const { theme } = useTheme();

  return (
    <ContainerSkeletonCard theme={theme} altura={altura} />
  );
};

export default SkeletonCardMetrica;
